<app-painel-lateral
    [tituloPainel]="'Cadastro Geral de Prestadores'"
    [descricaoPainel]="'Distribuição por UF: prestadores inscritos, ativos e localização (capital/interior/outros).'"
    [iconePainel]="'pi pi-building'"
    [filtrosTemplate]="filtros"
    [conteudoTemplate]="conteudo"
>
</app-painel-lateral>

<ng-template #filtros>
    <p-button label="Atualizar" icon="pi pi-refresh" (onClick)="aplicar()"></p-button>
</ng-template>

<ng-template #conteudo>
    @if (detalheAtivo) {
        <app-detalhamento-pendencias
            [indicador]="obterIndicadorDetalhe()"
            [linhas]="linhasDetalhe"
            [first]="firstDetalhe"
            [rows]="rowsDetalhe"
            [totalRecords]="totalDetalhe"
            [carregando]="carregandoDetalhe"
            [rotuloVoltar]="'Voltar ao cadastro geral'"
            [colunaIdentificador]="'CNPJ'"
            [colunaNome]="'RAZÃO SOCIAL'"
            [colunaDetalhe]="'Localização'"
            [voltarNoCard]="true"
            [permitirVisualizacaoCard]="true"
            (voltar)="voltarParaCards()"
            (paginaAlterada)="onPageChangeDetalhe($event)"
        >
        </app-detalhamento-pendencias>
    } @else if (carregando) {
        <div class="uf-grid">
            @for (s of skeletons; track s) {
                <p-skeleton width="100%" height="13rem" />
            }
        </div>
    } @else if (linhas.length) {
        @if (linhas.length > 1) {
            <app-card-content [border]="false" class="resumo-card" icon="pi pi-flag" [title]="'Brasil'" [subtitle]="linhas.length + ' UFs'">
                <div class="resumo-linha">
                    <div class="resumo-kpi">
                        <span class="resumo-num">{{ totais.inscritos | number }}</span>
                        <span class="resumo-num-label">inscritos</span>
                    </div>
                    <div class="resumo-kpi">
                        <span class="resumo-num">{{ percentual(totais.ativos, totais.inscritos) }}</span>
                        <span class="resumo-num-label">ativos</span>
                    </div>
                    <div class="barra-segmentada resumo-barra" aria-hidden="true">
                        <div class="seg seg-cap" [style.width.%]="segmento(totais.capital, totais.inscritos)"></div>
                        <div class="seg seg-int" [style.width.%]="segmento(totais.interior, totais.inscritos)"></div>
                        <div class="seg seg-out" [style.width.%]="segmento(totais.outrosEstados, totais.inscritos)"></div>
                        <div class="seg seg-sem" [style.width.%]="segmento(totais.semEndereco, totais.inscritos)"></div>
                    </div>
                    <div class="resumo-stats">
                        <span class="stat stat-cap"
                            ><span class="pontinho"></span><span class="stat-num">{{ totais.capital | number }}</span
                            ><span class="stat-lbl">capital</span></span
                        >
                        <span class="stat stat-int"
                            ><span class="pontinho"></span><span class="stat-num">{{ totais.interior | number }}</span
                            ><span class="stat-lbl">interior</span></span
                        >
                        <span class="stat stat-out"
                            ><span class="pontinho"></span><span class="stat-num">{{ totais.outrosEstados | number }}</span
                            ><span class="stat-lbl">outros estados</span></span
                        >
                        <span class="stat stat-sem"
                            ><span class="pontinho"></span><span class="stat-num">{{ totais.semEndereco | number }}</span
                            ><span class="stat-lbl">sem endereço</span></span
                        >
                    </div>
                </div>
            </app-card-content>
        }

        <div class="uf-grid">
            @for (l of linhas; track l.ufSgUf) {
                <app-card-content [border]="false" icon="pi pi-map-marker" [title]="l.ufSgUf" [subtitle]="(l.inscritos | number) + ' inscritos'">
                    <div class="uf-corpo">
                        <div class="uf-ativos" role="button" tabindex="0" style="cursor: pointer" title="Ver prestadores ativos" (click)="verDetalhe(l.ufSgUf, 'ATIVOS', 'Ativos')">
                            <span class="pontinho pontinho-ativos"></span>
                            <span class="uf-ativos-num">{{ l.ativos | number }}</span>
                            <span class="uf-ativos-lbl">ativos · {{ percentual(l.ativos, l.inscritos) }}</span>
                        </div>

                        <div class="uf-loc">
                            <span class="uf-loc-titulo">Localização</span>
                            <div class="barra-segmentada" aria-hidden="true">
                                <div class="seg seg-cap" [style.width.%]="segmento(l.capital, l.inscritos)"></div>
                                <div class="seg seg-int" [style.width.%]="segmento(l.interior, l.inscritos)"></div>
                                <div class="seg seg-out" [style.width.%]="segmento(l.outrosEstados, l.inscritos)"></div>
                                <div class="seg seg-sem" [style.width.%]="segmento(l.semEndereco, l.inscritos)"></div>
                            </div>
                            <div class="uf-loc-linhas">
                                <div class="loc loc-cap" role="button" tabindex="0" style="cursor: pointer" title="Ver prestadores na capital" (click)="verDetalhe(l.ufSgUf, 'CAPITAL', 'Capital')">
                                    <span class="pontinho"></span>
                                    <span class="loc-lbl">Capital</span>
                                    <span class="loc-num">{{ l.capital | number }}</span>
                                    <span class="loc-pct">{{ percentual(l.capital, l.inscritos) }}</span>
                                </div>
                                <div class="loc loc-int" role="button" tabindex="0" style="cursor: pointer" title="Ver prestadores no interior" (click)="verDetalhe(l.ufSgUf, 'INTERIOR', 'Interior')">
                                    <span class="pontinho"></span>
                                    <span class="loc-lbl">Interior</span>
                                    <span class="loc-num">{{ l.interior | number }}</span>
                                    <span class="loc-pct">{{ percentual(l.interior, l.inscritos) }}</span>
                                </div>
                                <div class="loc loc-out" role="button" tabindex="0" style="cursor: pointer" title="Ver prestadores em outra UF" (click)="verDetalhe(l.ufSgUf, 'OUTROS', 'Outra UF')">
                                    <span class="pontinho"></span>
                                    <span class="loc-lbl">Outros estados</span>
                                    <span class="loc-num">{{ l.outrosEstados | number }}</span>
                                    <span class="loc-pct">{{ percentual(l.outrosEstados, l.inscritos) }}</span>
                                </div>
                                <div class="loc loc-sem" role="button" tabindex="0" style="cursor: pointer" title="Ver prestadores sem endereço" (click)="verDetalhe(l.ufSgUf, 'SEM_ENDERECO', 'Sem endereço')">
                                    <span class="pontinho"></span>
                                    <span class="loc-lbl">Sem endereço</span>
                                    <span class="loc-num">{{ l.semEndereco | number }}</span>
                                    <span class="loc-pct">{{ percentual(l.semEndereco, l.inscritos) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </app-card-content>
            }
        </div>
    } @else {
        <div class="vazio">Sem dados de cadastro geral de prestadores.</div>
    }
</ng-template>
